<script setup>
  import { computed } from "vue";

  const props = defineProps({
    consumed: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    expired: { type: Boolean, default: false },
    showUnit: { type: Boolean, default: true },
    compact: { type: Boolean, default: true },
  });

  const percentage = computed(() => {
    if (props.total === 0) return 0;
    return Math.min(100, Math.round((props.consumed / props.total) * 100));
  });

  const indicatorClass = computed(() =>
    props.expired ? "bg-muted-foreground/40" : "bg-status-success",
  );
</script>

<template>
  <div class="flex items-center gap-3 w-full">
    <div
      class="bg-muted relative h-2 flex-1 overflow-hidden rounded-full"
      :class="{ 'max-w-32': compact }">
      <div
        class="h-full transition-all"
        :class="indicatorClass"
        :style="{ width: `${percentage}%` }" />
    </div>
    <span
      class="text-xs whitespace-nowrap"
      :class="expired ? 'text-muted-foreground' : 'text-foreground'">
      {{ consumed }} / {{ total }}<template v-if="showUnit"> credit(s)</template>
    </span>
  </div>
</template>
